import { getInitials } from "creso-core/utils";
import { cn } from "web-design-system";
import { Avatar, HoldingPatternBadge } from "web-core";
import { ClientHoldingPattern } from "creso-core/types";
import { JOINT_CLIENT_HOLDING_PATTERNS } from "creso-core/constants";

interface Props {
  name: string;
  url?: string;
  subtitle?: string;
  compact?: boolean;
  isActive?: boolean;
  holdingPattern?: ClientHoldingPattern;
}

export default function ClientAvatar(props: Props) {
  const {
    name,
    url,
    compact = false,
    subtitle,
    isActive,
    holdingPattern,
  } = props;

  return (
    <div className="flex justify-center">
      <div
        className={cn(
          "flex p-2 hover:bg-muted rounded-md cursor-default",
          compact
            ? "flex-row gap-2 items-start w-full"
            : "flex-col items-center gap-1"
        )}
      >
        <div className="relative">
          <Avatar fallback={getInitials(name ?? "")} url={url} size="sm" />
          {isActive && (
            <div className="size-2 bottom-0 absolute right-0 rounded-full bg-constructive" />
          )}
        </div>
        <div
          className={cn(
            "flex flex-col gap-1",
            compact ? "items-start" : "items-center"
          )}
        >
          <span className="text-center">
            <span className="font-medium text-sm text-center">{name}</span>{" "}
            {holdingPattern &&
            JOINT_CLIENT_HOLDING_PATTERNS.includes(holdingPattern) ? (
              <HoldingPatternBadge holdingPattern={holdingPattern} />
            ) : null}
          </span>
          <span className="text-xs text-muted-foreground">{subtitle}</span>
        </div>
      </div>
    </div>
  );
}
